import { ConnectButton } from "@/components/connect-button";
import {
  TransactionDialog,
  transactionInner,
} from "@/components/transaction/transaction-dialog";
import { N, shorten } from "@/lib/utils";
import { useWallet } from "@txnlab/use-wallet";
import { Wallet, UserRound, ChevronRight, ChevronLeft } from "lucide-react";
import { toLocaleString } from "@/lib/utils";
import { BenchStateFull } from "@myth-finance/bench-sdk";
import { decodeTransactions, getBenchInstanceClient } from "@/lib/clients";

export function WithdrawButton({
  data,
  reloadState,
  amount,
}: {
  data: BenchStateFull;
  reloadState: () => any;
  amount: number;
}) {
  const { activeAddress } = useWallet();

  const realAmount = data.purchaseAssetId === 0n ? amount - 200_000 : amount

  const makeWithdrawTransactions = async () => {
    return decodeTransactions(
      await getBenchInstanceClient(data.appId, data.registryAppId).makeWithdrawTxns({
        sender: activeAddress!,
        amount: BigInt(realAmount),
      })
    );
  };

  return (
    <TransactionDialog
      type="purchase"
      trigger={(onClick) => (
        <ConnectButton onClick={onClick} disabled={realAmount === 0}>
          <Wallet size={18} className="mr-1.5" />
          <span>
            Withdraw {realAmount / data.purchaseDecimalDenom}{" "}
            {data.purchaseUnitName}
          </span>
        </ConnectButton>
      )}
      transactionBuilder={() => makeWithdrawTransactions()}
      title={`Withdrawing ${data.sellingUnitName} bench revenue`}
      onClose={() => reloadState()}
      onSuccess={() => reloadState()}
    >
      {transactionInner(
        "operation",
        <>
          You are going to <strong>withdraw revenue</strong> from this bench
        </>,
        <>
          <div className="flex justify-between gap-2 mb-2">
            <div className="flex items-center">
              <UserRound size={18} className="mr-1" /> Account
            </div>{" "}
            <span>{shorten(activeAddress!)}</span>
          </div>

          <div className="flex justify-between gap-2 text-foreground">
            <div className="flex items-center">
              <ChevronRight size={18} className="mr-1" /> Call app: withdraw
            </div>
            <span>{N(data.appId)}</span>
          </div>

          <div className="flex justify-between gap-2 mt-2">
            <div className="flex items-center">
              {shorten(data.ownerAddr)}{" "}
              <ChevronLeft size={18} className="mr-1" />
            </div>{" "}
            <span className="text-right">
              {toLocaleString(realAmount / data.purchaseDecimalDenom)}{" "}
              {data.purchaseUnitName}
            </span>
          </div>
        </>
      )}
    </TransactionDialog>
  );
}
